export const createPhoneVerificationRequestKey = (smsToken?: string, verifyCode?: string) => {
  if (!smsToken || verifyCode?.length !== 6) return null;

  return `${smsToken}:${verifyCode}`;
};

export const shouldRequestPhoneVerification = ({
  requestKey,
  lastRequestKey,
}: {
  requestKey: string | null;
  lastRequestKey: string | null;
}) => {
  if (!requestKey) return false;

  return requestKey !== lastRequestKey;
};
